import DraggableList from './DraggableList.ts.vue';
import MultiplePropertySelect from './MultiplePropertySelect.vue';

export default [
  DraggableList,
  MultiplePropertySelect,
];
